import { Box, Image } from "@chakra-ui/react";
import React, { useMemo } from "react";
import { COMMON_WEB_PATH } from "../../../constant";
import useCheckLogin from "../../../hook/useCheckLogin";

const ReloadButton = () => {
  // 取 登入狀態 機台相關的狀態
  const { isLogin, isMachineDomain, isMachineUser } = useCheckLogin();

  const iconSize = useMemo(() => {
    return {
      base: "40px",
      md: "50px",
      xl: isMachineUser ? "80px" : "80px",
    };
  }, [isMachineUser]);

  const iconHeightSize = useMemo(() => {
    return {
      base: "30px",
      md: "40px",
      xl: isMachineUser ? "55px" : "55px",
    };
  }, [isMachineUser]);

  return (
    <Box
      onClick={() => {
        window.location.reload(); // 重新載入頁面
      }}
      position="relative"
      cursor="pointer"
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
      shadow="sm"
    >
      <Image
        src={`${COMMON_WEB_PATH}/now888/header/refresh_button.png`}
        height={iconHeightSize}
        //minW="50px"
        minW={iconSize}
        maxW={iconSize}
      />
    </Box>
  );
};

export default ReloadButton;
